// Laboratorní testy (nativní záložka Související soubory) — záložka hned za Hodnocení,
// odkazy na soubory jako karty: typ souboru, název, velikost. Název záložky je
// v shopDataLayer.productDetail.relatedFilesTitle (product-detail.js).
$(document).ready(function () {
    if (getShoptetDataLayer("pageType") !== "productDetail") return;

    const $pane = $("#relatedFiles");
    const $tab = $("#p-detail-tabs .shp-tab-link[href='#relatedFiles']").closest(".shp-tab");
    if (!$pane.length || !$tab.length) return;

    const $ratingTab = $("#p-detail-tabs .shp-tab-link[href='#ratingTab']").closest(".shp-tab");
    if ($ratingTab.length) {
        $tab.insertAfter($ratingTab);
        $pane.insertAfter("#ratingTab");
    }

    $pane.find("li > a").each(function () {
        const $link = $(this);
        const text = $link.text().trim();
        const match = text.match(/^(.*?)\s*\(([^()]+)\)$/);
        const name = match ? match[1] : text;
        const size = match ? match[2] : "";
        const extension = ($link.attr("href") || "").split("?")[0].split(".").pop();
        const type = extension.length > 0 && extension.length <= 4 ? extension.toUpperCase() : "";

        $link.addClass("myfile").empty();
        $("<span class='myfile-type' aria-hidden='true'></span>").text(type).appendTo($link);
        $("<span class='myfile-name'></span>").text(name).appendTo($link);
        if (size) {
            $("<span class='myfile-size'></span>").text(size).appendTo($link);
        }
    });
});
